
import { PDFDocument, rgb } from 'pdf-lib';

import fontkit from '@pdf-lib/fontkit';

import { capitalize } from '../utils.js';

import { fetchUint8Array, drawText, savePDF } from './utils.js';

import baskervilleItalic from '../fonts/baskerville-italic.ttf';

import bebasNeueRegular from '../fonts/bebas-neue-regular.ttf';

import openSansRegular from '../fonts/open-sans-regular.ttf';

import openSansBold from '../fonts/open-sans-bold.ttf';

import template from './activity-5-poster-3.pdf';

import { posterStyles } from '../stores/activity-5.js';

import squarePlaceholderPath from '../images/activity-5-square-placeholder.png';

import verticalPlaceholderPath from '../images/activity-5-vertical-placeholder.png';

const style = posterStyles.find( ( { id } ) => id === 3 );

export async function exportPDF( firstName, lastName ) {

  const serifFontBytes = await fetchUint8Array( baskervilleItalic );

  const headingFontBytes = await fetchUint8Array( bebasNeueRegular );

  const sansFontBytes = await fetchUint8Array( openSansRegular );
  
  const sansBoldFontBytes = await fetchUint8Array( openSansBold );

  const templateBytes = await fetchUint8Array( template );
  
  const topImageBytes = await fetch( style.topImagePath ?? verticalPlaceholderPath ).then( data => data.arrayBuffer() );

  const bottom1ImageBytes = await fetch( style.bottom1ImagePath ?? squarePlaceholderPath ).then( data => data.arrayBuffer() );

  const bottom2ImageBytes = await fetch( style.bottom2ImagePath ?? squarePlaceholderPath ).then( data => data.arrayBuffer() );

  const doc = await PDFDocument.load( templateBytes );
  
  doc.registerFontkit( fontkit );

  const serifFont = await doc.embedFont( serifFontBytes, { subset: true } );

  const headingFont = await doc.embedFont( headingFontBytes, { subset: true } );

  const sansFont = await doc.embedFont( sansFontBytes );
  
  const sansBoldFont = await doc.embedFont( sansBoldFontBytes );

  const topImage = await doc.embedPng( topImageBytes );

  const bottom1Image = await doc.embedPng( bottom1ImageBytes );

  const bottom2Image = await doc.embedPng( bottom2ImageBytes );

  const page = doc.getPages()[ 0 ];

  const topImageScaled = topImage.scaleToFit( 200, page.getHeight() );

  page.drawImage( topImage, {
    
    x: page.getWidth() - topImageScaled.width,
    
    y: page.getHeight() - topImageScaled.height - 35,
    
    width: topImageScaled.width,
    
    height: topImageScaled.height
  
  } );

  const bottom1ImageScaled = bottom1Image.scaleToFit( 200, page.getHeight() );

  page.drawImage( bottom1Image, {
    
    x: page.getWidth() - bottom1ImageScaled.width,
    
    y: page.getHeight() - topImageScaled.height - 35 - bottom1ImageScaled.height,
    
    width: bottom1ImageScaled.width,
    
    height: bottom1ImageScaled.height
  
  } );

  const bottom2ImageScaled = bottom2Image.scaleToFit( 200, page.getHeight() );

  page.drawImage( bottom2Image, {
    
    x: page.getWidth() - bottom2ImageScaled.width,
    
    y: page.getHeight() - topImageScaled.height - 35 - bottom1ImageScaled.height - bottom2ImageScaled.height,
    
    width: bottom2ImageScaled.width,
    
    height: bottom2ImageScaled.height
  
  } );  

  {

    let x = 30, y = 46, height = 0;

    ( { y, height } = 

      drawText( {
        
        doc, page, x, y, align: 'top left',
        
        font: headingFont, size: 28, maxWidth: 325, color: 0xffffff,
        
        text: ( style.title || 'No title.' ).replace( /\n/g, ' ' ).toUpperCase()
      
      } ) );

    ( { y, height } =
      
      drawText( {
      
        doc, page, x, y: y + height + 10, align: 'top left',
        
        font: sansFont, size: 10, maxWidth: 325, color: 0xffffff,
        
        text: ( style.subtitle || 'No subtitle.' ).replace( /\n/g, ' ' )
      
      } ) );

  }

  {

    let x = 30, y = 170, height = 0;

    ( { y, height } = 

      drawText( {
        
        doc, page, x, y, align: 'top left',
        
        font: serifFont, size: 16, lineHeight: 35, maxWidth: 325, color: 0xffffff,
        
        text: `"${ ( style.quote || 'No quote.' ).replace( /\n/g, ' ' ) }"`
      
      } ) );

    ( { y, height } =
      
      drawText( {
      
        doc, page, x: x + 325, y: y + height + 15, align: 'top right',
        
        font: sansFont, size: 10, color: 0xffffff,
        
        text: `- ${ ( style.citation || 'No citation.' ).replace( /\n/g, ' ' ) }`
      
      } ) );

  }

  {

    let x = 30, y = 395, height = 0;

    ( { y, height } = 

      drawText( {
        
        doc, page, x, y, align: 'top left',
        
        font: sansBoldFont, size: 14, lineHeight: 40, maxWidth: 325, color: 0xffffff,
        
        text: ( style.bottom1ImageTitle || 'No title.' ).replace( /\n/g, ' ' )
      
      } ) );

    ( { y, height } =
      
      drawText( {
      
        doc, page, x, y: y + height + 10, align: 'top left',
        
        font: sansFont, size: 10, maxWidth: 325, lineHeight: 16, color: 0xffffff,
        
        text: ( style.bottom1ImageCaption || 'No caption.' ).replace( /\n/g, ' ' )
      
      } ) );

  }

  {

    let x = 30, y = 595, height = 0;

    ( { y, height } = 

      drawText( {
        
        doc, page, x, y, align: 'top left',
        
        font: sansBoldFont, size: 14, lineHeight: 40, maxWidth: 325, color: 0xffffff,
        
        text: ( style.bottom2ImageTitle || 'No title.' ).replace( /\n/g, ' ' )
      
      } ) );

    ( { y, height } =
      
      drawText( {
      
        doc, page, x, y: y + height + 10, align: 'top left',
        
        font: sansFont, size: 10, maxWidth: 325, lineHeight: 16, color: 0xffffff,
        
        text: ( style.bottom2ImageCaption || 'No caption.' ).replace( /\n/g, ' ' )
      
      } ) );

  }

  drawText( {
    
    doc, page, x: 30, y: 760, align: 'top left',
    
    font: sansBoldFont, size: 10, color: 0xffffff,
    
    text: `Poster created by: ${ capitalize( firstName ) } ${ capitalize( lastName ) } (${ new Date().toLocaleString().split( ',' )[ 0 ] })`
  
  } );

  doc.setTitle( 'Activity Five - Poster 3' );
  
  doc.setSubject( 'Lewis Mountain' );
  
  doc.setCreator( 'Shenandoah National Park' );
    
  doc.setAuthor( 'National Park Service' );

  doc.setProducer( 'PDF-LIB (https://github.com/Hopding/pdf-lib)' );
  
  doc.setCreationDate( new Date() );
  
  doc.setModificationDate( new Date() );
  
  savePDF( `Lewis-Mountain-Activity-5-${ capitalize( firstName ) }-${ capitalize( lastName ) }`, doc );
  
}